<div>
    @if(navRequired){
    <div class="flex justify-between items-center p-2">
        <span class="text-lg font-bold">Compare History</span>
        @if(role === CONTRACT_USER_ROLE.OWNER || role === CONTRACT_USER_ROLE.EDITOR){
        <app-button icon="pi pi-plus-circle" variant="filled" severity="primary" label="New"
            (clicked)="openCompareDialog()" />
        }
    </div>
    <hr>
    }
    <div class="flex flex-col gap-2 pt-2">
        @if(loading){
        <div class="flex justify-center items-center h-full">
            <p-progressSpinner class="my-4" [style]="{width: '1.875rem', height: '1.875rem'}"></p-progressSpinner>
        </div>
        }
        @else{
        <div class="my-3 items-center">
            <app-search-bar placeholder="Search a comparison" (searchChange)="searchCompares($event)"
                width="100%"></app-search-bar>
        </div>
        <p-accordion class="w-full" [value]="['0']" class="border-t">
            @for (item of filteredHistory; track $index) {
            <p-accordion-panel [value]="$index.toString()" class="border-b">
                <p-accordion-header>
                    <span class="flex w-full items-center justify-between">
                        <div class="flex flex-col" (click)="$event.stopPropagation(); openComparison(item._id)">
                            <span class="text-lg font-semibold">{{item?.name}}
                                <i class="pi pi-external-link small-icon"></i>
                            </span>
                            <span class="text-xs font-normal text-gray-400">{{item.updatedAt |
                                date: 'medium'}}</span>
                        </div>
                    </span>
                </p-accordion-header>
                <p-accordion-content>
                    <div class="rounded-base">
                        <div class="flex flex-col justify-between p-1">
                            <div class="justify-between grid grid-cols-2 gap-2 p-2 ">
                                @for (compareDoc of item.compareContracts; track $index) {
                                <div class="border p-2 rounded-base">
                                    <div class="flex gap-2 items-center justify-between">
                                        <div class="flex gap-1 items-center">

                                            <i class="pi pi-file"></i>
                                            <span class="font-medium">{{(compareDoc.docModel ==
                                                DOCUMENT_MODEL.UPLOADED_DOCUMENT ? compareDoc?.doc?.filename :
                                                compareDoc?.doc?.name) | truncate:10}}</span>
                                        </div>
                                        <div class="cursor-pointer"
                                            (click)="openDocument(compareDoc._id ,compareDoc.docModel)">
                                            <i class="pi pi-external-link small-icon"></i>
                                        </div>
                                    </div>
                                </div>
                                }
                            </div>
                            <div class="flex justify-between items-center">
                                <div class="flex gap-2 items-center">
                                    <div class="flex flex-col">
                                        <app-user-name-display [user]="item.createdBy" [variant]="'avatar-name'"></app-user-name-display>
                                        <span class="text-xs font-medium">{{item.createdBy.email}}</span>
                                    </div>
                                </div>
                                <div class="items-center">
                                    @if(role === CONTRACT_USER_ROLE.OWNER || role === CONTRACT_USER_ROLE.EDITOR){
                                    <app-button icon="pi pi-trash"
                                        (clicked)="confirmDeleteComparison(item._id, item.name)" variant="outlined"
                                        severity="danger" />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </p-accordion-content>
            </p-accordion-panel>
            }
        </p-accordion>
        }
        @if((filteredHistory.length ==0 || history.length === 0) && !loading) {
        <div class="flex justify-center items-center h-32">
            <span class="text-lg font-semibold text-gray-500">No history found</span>
        </div>
        }
    </div>

    <app-compare-selection [contractId]="documentId" [documentType]="documentType" [projectId]="projectId"
        [(visible)]="showCompareSelection" (closed)="onCompareSelectionClosed($event)">
    </app-compare-selection>

    <app-delete-confirmation [(visible)]="showDeleteDialog" confirmButtonText="Yes, delete"
        [headerText]="'Delete ' + selectedComparisonName + ' Comparison?'"
        [bodyText]="'The comparison and the data associated with it will be permanently deleted.'"
        (onConfirm)="deleteComparison()">
    </app-delete-confirmation>
</div>